import React, { useEffect } from 'react';
import {
  Grid,
  makeStyles,
  TextField,
} from '@material-ui/core';

import {
  InputTitle,
  inputLabelProps,
  inputMUIDefaultStyles,
} from '../styles/FormStyles';
import { IUseFormData } from '../contracts';
import {
  IMaskInputCPF,
  IMaskInputDate,
} from './IMaskInput';
import { SelectInput } from './SelectInput';
import { statesList } from '../helpers/statesListMock';
import {
  birthDateValidation,
  cpfValidation,
  nameValidation,
} from '../validations/forms';

const useStyles = makeStyles((theme) => ({
  marginTopXs: {
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(3),
    },
  },
}));

interface PharmaceuticalInputBoxProps {
  formData: IUseFormData;
  defaultValue?: {
    cpf?: string;
    crf?: string;
    crfUf?: string;
  };
  isDisabled?: boolean;
}

export function PharmaceuticalInputBox({
  formData,
  defaultValue,
  isDisabled,
}: PharmaceuticalInputBoxProps): JSX.Element {
  const {
    register,
    errors,
    setValue,
  } = formData;

  const classes = useStyles();

  const dateHelperText = defaultValue
    ? undefined
    : 'dd/mm/aaaa';

  const crfIsDisabled =
    isDisabled || Boolean(defaultValue?.crf);

  const crfUfIsDisabled =
    isDisabled || Boolean(defaultValue?.crfUf);

  useEffect(() => {
    if (
      defaultValue?.crf
      && defaultValue?.crfUf
    ) {
      setValue('crf', defaultValue.crf);
      setValue('crfUf', defaultValue.crfUf);
    }
  }, [
    defaultValue?.crf,
    defaultValue?.crfUf,
    setValue,
  ]);

  return (
    <>
      <InputTitle>
        Dados do Farmacêutico*
      </InputTitle>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            variant="outlined"
            disabled={crfIsDisabled}
            label="CRF"
            defaultValue={defaultValue?.crf}
            style={inputMUIDefaultStyles.normal}
            error={Boolean(errors.crf)}
            helperText={
              errors.crf
                ? errors.crf.message
                : ''
            }
            {...register('crf')}
            InputLabelProps={{
              ...inputLabelProps,
              shrink: true,
            }}
            inputProps={{
              maxLength: 5,
            }}
            fullWidth
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          style={{ marginTop: '-10px' }}
        >
          <SelectInput
            title="CRF UF *"
            disabled={crfUfIsDisabled}
            list={statesList}
            style={inputMUIDefaultStyles.normal}
            value={defaultValue?.crfUf}
            formData={formData}
            propertieFormName="crfUf"
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          style={{ marginTop: '10px' }}
        >
          <TextField
            required
            variant="outlined"
            label="CPF"
            disabled={Boolean(defaultValue?.cpf)}
            style={inputMUIDefaultStyles.normal}
            error={Boolean(errors.cpf)}
            helperText={
              errors.cpf
                ? errors.cpf.message
                : ''
            }
            {...register('cpf', cpfValidation)}
            InputLabelProps={{
              ...inputLabelProps,
              shrink: true,
            }}
            InputProps={{
              inputComponent: IMaskInputCPF as any,
            }}
            fullWidth
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          style={{ marginTop: '10px' }}
        >
          <TextField
            required
            variant="outlined"
            disabled={isDisabled}
            label="Data de nascimento"
            style={inputMUIDefaultStyles.normal}
            error={Boolean(errors.birthDate)}
            helperText={
              errors.birthDate
                ? errors.birthDate.message
                : dateHelperText
            }
            {...register(
              'birthDate',
              birthDateValidation,
            )}
            InputLabelProps={{
              ...inputLabelProps,
              shrink: true,
            }}
            InputProps={{
              inputComponent: IMaskInputDate as any,
            }}
            fullWidth
            className={classes.marginTopXs}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          style={{ marginTop: '30px' }}
        >
          <TextField
            required
            variant="outlined"
            label="Nome"
            style={inputMUIDefaultStyles.large}
            error={Boolean(errors.name)}
            helperText={
              errors.name
                ? errors.name.message
                : ''
            }
            {...register('name', nameValidation)}
            InputLabelProps={{
              ...inputLabelProps,
              shrink: true,
            }}
            inputProps={{
              maxLength: 150,
            }}
            fullWidth
          />
        </Grid>
      </Grid>
    </>
  );
}
